<mat-list
  class="list-config"
  [ngClass]="{'transparent': isTransparent}"
  data-cy="mojo-collection-list"
>
  <ng-container *ngIf="enableAnimation; else noAnimationContent">
    <mat-list-item
      @insertRemoveTrigger
      *ngFor="let item of items; trackBy:trackElement"
    >
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
      >
      </ng-container>
    </mat-list-item>
  </ng-container>

  <ng-template #noAnimationContent>
    <mat-list-item *ngFor="let item of items; trackBy: trackElement">
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
      >
      </ng-container>
    </mat-list-item>
  </ng-template>
</mat-list>
